/**
 * @file useCreateTabs.ts
 * @author markJia(markjia@tencent.com)
 */
import { useRefCallback, useSingleton, useUpdate } from '@tencent/glue-react-use';
import { useEffect } from 'react';
import { Tabs } from '@tencent/glue-model-tabs';
export var useCreateTabs = function useCreateTabs(ops) {
  var _ops$closable = ops.closable,
      closable = _ops$closable === void 0 ? false : _ops$closable,
      _ops$disabled = ops.disabled,
      disabled = _ops$disabled === void 0 ? false : _ops$disabled,
      value = ops.value,
      onValueChange = ops.onValueChange;
  var update = useUpdate();
  var model = useSingleton(function () {
    return new Tabs({
      activeId: value
    });
  });
  model.updateTabsOptions({
    disabled: disabled,
    value: value,
    closable: closable
  });
  var valueChange = useRefCallback(onValueChange);
  useEffect(function () {
    model.addListener('active-id-change', valueChange);
    model.addListener('tabs-header-change', update);
    return function () {
      model.removeListener('active-id-change', valueChange);
      model.removeListener('tabs-header-change', update);
      model.dispose();
    };
  }, []);
  return model;
};